import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");

  const phoneNumber = "923217830991"; // WhatsApp number in proper format
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  const handleSend = () => {
    if (message.trim() !== "") {
      window.open(whatsappURL, "_blank");
      setMessage("");
    }
  };

  return (
    <div className="fixed bottom-5 right-5 flex flex-col items-end z-50">
      {/* Chat Panel */}
      {isOpen && (
        <div className="w-72 bg-white shadow-lg rounded-lg flex flex-col p-4 mb-2">
          <div className="flex justify-between items-center mb-2">
            <h3 className="font-bold text-green-600">Chat with us</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message..."
            className="w-full border border-gray-300 rounded-md p-2 mb-2 focus:outline-none focus:ring-2 focus:ring-green-500"
            rows={3}
          />
          <button
            onClick={handleSend}
            className="bg-green-500 text-white rounded-md py-2 hover:bg-green-600 transition"
          >
            Send
          </button>
        </div>
      )}

      {/* Floating WhatsApp Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-green-500 p-4 rounded-full shadow-lg text-white hover:bg-green-600 transition flex items-center justify-center text-2xl"
      >
        <FaWhatsapp />
      </button>
    </div>
  );
};

export default WhatsAppWidget;
